import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import type { PostCatalogProductBody } from '@snootsvet/shared'

import { useViewerRegion } from '@/frontend/features/region/region-context'
import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Creates a catalog product entry in the active region, then invalidates the catalog list cache. */
export function useCreateCatalogProduct() {
  const api = useOsApi()
  const { region } = useViewerRegion()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: Omit<PostCatalogProductBody, 'region'>) => {
      const response = await api.post('/products/catalog', { body: { ...body, region } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.product
    },
    onSuccess: (product) => {
      queryClient.invalidateQueries({ queryKey: ['catalog-products'] })
      toast.success(`Added ${product.name} – ${product.formulation} to the product catalog`)
    },
    onError: (error) => {
      toast.error(error.message)
    },
  })
}
